import Button from 'components/base/Button';
import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, Row, FormGroup, FormLabel } from 'react-bootstrap';
import * as Yup from 'yup';
import { employeeOptions, organizationTypeOptions } from './config';
import { BasicInfo } from './company.type';
import { useDispatch } from 'react-redux';
import { updateRecruiter } from 'reducers/AuthReducer';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

const validationSchema = Yup.object({
  name: Yup.string().required('Company / Consultant Name is required'),
  email: Yup.string().email().required('Email address is required'),
  address: Yup.string().required('Address is required'),
  type: Yup.string().required('Type is required'),
  numberOfEmployees: Yup.string().required('Number of Employees is required')
});

function Company() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { name, email, type, address, numberOfEmployees } = useSelector(
    (state: RootState) => state.auth.register.recruiter
  );

  const handleSubmit = (values: BasicInfo) => {
    dispatch(updateRecruiter(values));
    navigate('/register/recruiter/contact');
  };
  return (
    <>
      <div className="position-relative mt-4">
        <hr className="bg-body-secondary" />
        <div className="divider-content-center">Company Information</div>
      </div>
      <Formik
        initialValues={{
          name: name || '',
          email: email || '',
          type: type || '',
          address: address || '',
          numberOfEmployees: numberOfEmployees || ''
        }}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
      >
        <Form>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="name">Company / Consultant Name</FormLabel>
            <Input
              name="name"
              id="name"
              placeholder="Company / Consultant Name"
            />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="email">Email address</FormLabel>
            <Input
              name="email"
              id="email"
              type="email"
              placeholder="name@example.com"
            />
          </FormGroup>
          <FormGroup className="mb-3 text-start">
            <FormLabel htmlFor="type">Type</FormLabel>
            <Select name="type" id="type" options={organizationTypeOptions} />
          </FormGroup>
          <Row className="g-3 mb-3">
            <Col sm={12} lg={6}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="address">Address</FormLabel>
                <Input name="address" id="address" />
              </FormGroup>
            </Col>
            <Col sm={12} lg={6}>
              <FormGroup className="mb-3 text-start">
                <FormLabel htmlFor="numberOfEmployees">
                  Number of Employees
                </FormLabel>
                <Select
                  name="numberOfEmployees"
                  id="numberOfEmployees"
                  options={employeeOptions}
                />
              </FormGroup>
            </Col>
          </Row>
          <Button variant="primary" type="submit" className="w-100 mb-3">
            Next
          </Button>
        </Form>
      </Formik>
    </>
  );
}

export default Company;
